import { SET_OVERLAY_VISIBLE } from "../constants/overlay";

export const setOverlayVisible = (props) => ({type: SET_OVERLAY_VISIBLE, ...props});